// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"18bdb3e3","827":"de7474c4","879":"73559f0e","929":"ca5221e1"}[chunkId] + ".chunk.css";
};